"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParentNode = exports.removeClass = exports.addClass = exports.toggleClass = exports.hasClass = exports.triggerEvent = exports.attachEvent = void 0;
var ArrayUtils_1 = __importDefault(require("./ArrayUtils"));
/**
 * Bind an event to the DOM, specifying the function that will be executed when the event is triggered.
 *
 * @param eventName The name of the event to attach to a target.
 * @param handler The callback function that will be executed when the event is triggered.
 * @param el Optional; the DOM element upon which to bind this event. If not specified, `window.document` is used.
 */
exports.attachEvent = function (eventName, handler, el) {
    if (el === void 0) { el = getDefaultEventTarget(); }
    if (el) {
        el.addEventListener(eventName, handler, false);
    }
};
/**
 * Trigger a given event, which will execute all event handlers that have been bound within its DOM tree.
 *
 * @param eventName The name of the event to trigger.
 */
exports.triggerEvent = function (eventName, eventData, el) {
    if (el === void 0) { el = getDefaultEventTarget(); }
    if (el) {
        var event_1 = document.createEvent('HTMLEvents');
        event_1.initEvent(eventName, true, true);
        event_1.eventName = eventName;
        event_1.data = eventData;
        el.dispatchEvent(event_1);
    }
};
exports.hasClass = function (element, className) {
    if (element.classList) {
        return ArrayUtils_1.default.containsAll(__spread(element.classList), className.split(' '));
    }
    else if (element && element.className) {
        var classes = element.className.split(' ');
        if (!multipleClassesPassed(className)) {
            return classes.indexOf(className) !== -1;
        }
        return ArrayUtils_1.default.containsAll(classes, className.split(' '));
    }
    return false;
};
exports.toggleClass = function (element, className) {
    if (element.classList) {
        element.classList.toggle(className);
    }
    else if (exports.hasClass(element, className)) {
        exports.removeClass(element, className);
    }
    else {
        exports.addClass(element, className);
    }
};
exports.addClass = function (element, className) {
    if (!multipleClassesPassed(className)) {
        // Only a single class is to be added
        addSingleClass(element, className);
    }
    else {
        // Multiple classes are to be added
        var classArr = className.split(' ');
        classArr.forEach(function (singleClass) {
            // Ignore classes that have no length (e.g. when multiple spaces exist between classes in provided arg)
            if (singleClass.length > 0) {
                addSingleClass(element, singleClass);
            }
        });
    }
};
exports.removeClass = function (element, className) {
    if (exports.hasClass(element, className)) {
        if (!multipleClassesPassed(className)) {
            removeSingleClass(element, className);
        }
        else {
            className.split(' ').forEach(function (cls) { return removeSingleClass(element, cls); });
        }
    }
};
exports.getParentNode = function (startingNode, searchClass) {
    if (startingNode && startingNode.parentNode && searchClass) {
        if (startingNode.parentNode.className) {
            var classes = startingNode.parentNode.className.split(' ');
            if (classes.indexOf(searchClass) !== -1) {
                return startingNode.parentNode;
            }
        }
        return exports.getParentNode(startingNode.parentNode, searchClass);
    }
    return null;
};
exports.default = {
    addClass: exports.addClass,
    attachEvent: exports.attachEvent,
    hasClass: exports.hasClass,
    getParentNode: exports.getParentNode,
    removeClass: exports.removeClass,
    toggleClass: exports.toggleClass,
    triggerEvent: exports.triggerEvent
};
var multipleClassesPassed = function (className) {
    return className.indexOf(' ') !== -1;
};
var addSingleClass = function (element, className) {
    if (!exports.hasClass(element, className)) {
        if (element.classList) {
            element.classList.add(className);
        }
        else if (element.className.length > 0) {
            // Add new className to existing classNames
            var classes = element.className.split(' ');
            classes.push(className);
            element.className = classes.join(' ');
        }
        else {
            // Directly assign className to prevent adding leading whitespace to className from .split/.join operation
            element.className = className;
        }
    }
};
var removeSingleClass = function (element, className) {
    if (element.classList) {
        element.classList.remove(className);
    }
    else if (element.className.length > 0) {
        element.className = element.className.split(' ').filter(function (cls) { return cls !== className; }).join('');
    }
};
var getDefaultEventTarget = function () {
    return typeof window !== 'undefined' ? window.document : null;
};
